import style from "../blog.module.css";
import ExpandableText from "../TextoExpandible";
import React from "react";

const P2: React.FC = () => {
  const Notice1 = `
  El objeto del presente Proyecto de Acuerdo es disponer obligaciones, competencias y responsabilidades claras en cabeza de los organismos de la administración Distrital de Santiago de Cali, para efectos de lograr la correcta institucionalización del día de la población campesina en Santiago de Cali, con acciones que permitan la progresiva materialización de los derechos fundamentales de estos sujetos de especial protección constitucional en cuanto a sus dimensiones económica, social, cultural, política y ambiental, dando cumplimiento a lo consagrado en el artículo 64 de la Constitución Nacional y a los deberes establecidos en la Ley 2223 de 2022, reconociendo la importancia superlativa de este grupo poblacional que encarna valores, principios y virtudes meritorias de un reconocimiento especial debido a su enorme contribución al sostenimiento de la seguridad alimentaria y cuidado de la tierra en nuestra ciudad.
  `;

  return (
    <section className={style.Noticia}>
      <div className={style.ContainerPDF}>
        <iframe
          title="Proposicion 046"
          src="https://drive.google.com/file/d/1lfTXwniBo7MwCmyFnJ4edhYvTClt7545/preview"
          className={style.PdfViewer}
          allow="autoplay"
        />
      </div>
      <div className={style.Separador}></div>
      <div className={style.NoticeBox}>
        <h1 className={style.Tittle}>
          Proposicion 046: Proyecto de Acuerdo Día de la Población Campesina{" "}
        </h1>
        <h5 className={style.Fecha}>Junio 05 del 2025</h5>
        <ExpandableText text={Notice1} limit={800} />
        <p className={style.reportero}>
          Oficina de Comunicaciones Concejal Rodrigo Salazar, Partido Alianza
          Verde{" "}
        </p>
      </div>
    </section>
  );
};

export default P2;
